export default __webpack_public_path__ + "static/8-64484d2b26371f5d37d29f9fb19a9f9f.jpg";